import {observer} from "mobx-react";
import * as React from "react";
import {Comment} from "./Comment";
import CommentAdd from "./CommentAdd";

import './CommentBlock.pcss';
import {CommentDataInterface} from "../../../data/FullPostModalData";
import {User} from "../../../data/entities/User";
import {UIState} from "data/UIState";
import UserDataSource from "data/UserDataSource";
import {action, computed, observable} from "mobx";
import {IMentionUser} from "shared/IMentionUser";
import {
  CollapsedNotificationMessageMulti,
  CollapsedNotificationMessageSingular
} from "components/widgets/Notification/Notification";
import {UIStateVendor} from "data/UIStateVendor";


interface ICommentBlockProps {
  comments:any[];
  addComment:(commentData:CommentDataInterface)=>Promise<void>;
  commentPeriodHasEnded:boolean;
  user:User;
  postAuthor:User|null;
  post:any;
}

@observer
export class CommentBlock extends React.Component<ICommentBlockProps> {

  @observable possibleUsersToMention:IMentionUser[];

  constructor(props:ICommentBlockProps) {
    super(props);

    // Vendor
    if(UIStateVendor.isLoggedIn) {
      if(UIStateVendor.selectedSolutionId) {
        UserDataSource.loadMentionUsersForSolution(UIStateVendor.selectedSolutionId, true).then(this.handleLoadUsersSuccess).catch(() => {
          console.log("Failed to load mention users.");
        });
      } else {
        console.log("No solution available, impossible to mention users.");
      }
    }
    // Client User
    else {
      if(UIState.feedData && UIState.feedData.solution) {
        UserDataSource.loadMentionUsersForSolution(UIState.feedData.solution._id).then(this.handleLoadUsersSuccess).catch(()=>{
          console.log("Failed to load mention users.");
        });
      } else {
        console.log("No solution available, impossible to mention users.");
      }
    }
  }

  @action handleLoadUsersSuccess = (possibleUsersToMention:IMentionUser[]) => {
    for(let i=0; i<possibleUsersToMention.length; i++){
      possibleUsersToMention[i].display = " @"+possibleUsersToMention[i].display+" ";
    }
    if(this.props.postAuthor) {
      const authorMentionUser:IMentionUser = {
        id:this.props.postAuthor._id,
        display:" @"+this.props.postAuthor.nameOrNickname+" "
      }
      possibleUsersToMention.push(authorMentionUser);
    }
    this.possibleUsersToMention = possibleUsersToMention;
  }

  @computed get allRelatedNotifications() {
    return UIState.collapsedNotificationTarget && this.props.post._id===UIState.collapsedNotificationTarget.postId ?  UIState.collapsedNotificationTarget.allNotifications() : [];
  }


  render(){
    const {comments} = this.props;

    return (
      <div className="comment-block">
        <div className="cb-header">
        <h2 className={'level2 shadow'}>Comments</h2>
          <div className="notification-message">
            {this.allRelatedNotifications.length>0
              && <>
              {this.allRelatedNotifications.length==1 ?
                <CollapsedNotificationMessageSingular collapsedNotification={UIState.collapsedNotificationTarget} />
                :
                <CollapsedNotificationMessageMulti collapsedNotification={UIState.collapsedNotificationTarget} />
              }
              </>
            }
          </div>
        </div>

        <div className={"cb-body"} >
          <div role={'list'} aria-label={"Comments"} >
            {comments.map((comment, idx) =>
              <Comment
                key={idx}
                comment={comment}
                addReply={this.props.addComment}
                commentPeriodHasEnded={this.props.commentPeriodHasEnded}
                possibleUsersToMention={this.possibleUsersToMention}
                possibleRelatedNotifications={this.allRelatedNotifications}
              />
            )}
          </div>
          {this.props.commentPeriodHasEnded ?
            <p>Commenting has concluded.</p>
            :
            <CommentAdd addComment={this.props.addComment} user={this.props.user} possibleUsersToMention={this.possibleUsersToMention} />
          }
        </div>
      </div>
    );
  }

}
